import React from 'react';
import CheckButton from '../../components/CheckButton';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Answer = {
    name: string;
    value: string;
}

const PsychlngclCheckHappy: React.FC = () => {
    const answers: Answer[] = [];
    const goResult = (type: string) => {
        if ("cancel" === type) {
            if(window.confirm("정말 취소 하시겠습니까? '확인' 버튼을 누르면 심리검사목록 페이지로 이동합니다.")) {
                alert("취소되었습니다.");
                window.location.href="/psychlgclCheck/main";
            }
        } else if ("success" === type) {
            if (answers.length < 3) {
                alert("아직 응답하지 않은 문항이 있습니다.");
                return;
            } else {
                let total = 0;
                answers.map((answer) => (
                    total += parseInt(answer.value)
                ));
                let resultCode = '';
                if (3 <= total && total < 13) {
                    resultCode = "001";
                } else if (12 < total && total < 17) {
                    resultCode = "002";
                } else if (16 < total && total < 21) {
                    resultCode = "003";
                } else if (20 < total && total < 25) {
                    resultCode = "004";
                } else if (24 < total && total < 29) {
                    resultCode = "005";
                }
                window.location.href=`/psychlgclCheck/happy/result/${resultCode}/${total}`;
            }
        }
    }

    const handleRadioChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value, name} = e.target;
        if (answers.length > 0) {
            // name이 존재하면
            if (answers.findIndex((element) => element.name === name) !== -1) {
                answers[answers.findIndex((element) => element.name === name)].value = value;
            } else {
                answers.push({name: name, value: value});    
            }
        } else {
            answers.push({name: name, value: value});
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className="contents">
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='불안 자가진단'
                        />
                        <div className="mobileface testing">
                            <div className="testWrap happy">
                                <h3 className="f18 black">행복 자가진단</h3>
                                <div className="visualBox mt23">
                                    <p className="black lh30">
                                        <strong className="f16">지난 1주일 동안의 느낌이나 상태에 대한 질문입니다.</strong><br/>
                                        각각의 일들이 1주일 동안 얼마나 자주 있었는지 체크해 주십시오. 
                                    </p>
                                </div>
                                <h4 className="f14 green mt30">행복 자가진단 진행 (4문항)</h4>
                                <fieldset>
							        <ul className="etc_list col6">
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">1. 나는 외향적이고 변화에 유연한 편이다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="hq1" value="1" onChange={handleRadioChnage}/> 전혀 아님</label>
                                                    <label><input type="radio" name="hq1" value="3" onChange={handleRadioChnage}/> 많이 아님</label>
                                                    <label><input type="radio" name="hq1" value="4" onChange={handleRadioChnage}/> 약간 아님</label>
                                                    <label><input type="radio" name="hq1" value="5" onChange={handleRadioChnage}/> 보통</label>
                                                    <label><input type="radio" name="hq1" value="6" onChange={handleRadioChnage}/> 약간 그러함</label>
                                                    <label><input type="radio" name="hq1" value="7" onChange={handleRadioChnage}/> 많이 그러함</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">2. 나는 긍정적이고 우울한 기분에서 비교적 빨리 탈출한다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="hq2" value="1" onChange={handleRadioChnage}/> 전혀 아님</label>
                                                    <label><input type="radio" name="hq2" value="3" onChange={handleRadioChnage}/> 많이 아님</label>
                                                    <label><input type="radio" name="hq2" value="4" onChange={handleRadioChnage}/> 약간 아님</label>
                                                    <label><input type="radio" name="hq2" value="5" onChange={handleRadioChnage}/> 보통</label>
                                                    <label><input type="radio" name="hq2" value="6" onChange={handleRadioChnage}/> 약간 그러함</label>
                                                    <label><input type="radio" name="hq2" value="7" onChange={handleRadioChnage}/> 많이 그러함</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">3. 나는 건강, 돈, 안전, 자유 등에 기본적으로 만족하고 있다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="hq3" value="1" onChange={handleRadioChnage}/> 전혀 아님</label>
                                                    <label><input type="radio" name="hq3" value="3" onChange={handleRadioChnage}/> 많이 아님</label>
                                                    <label><input type="radio" name="hq3" value="4" onChange={handleRadioChnage}/> 약간 아님</label>
                                                    <label><input type="radio" name="hq3" value="5" onChange={handleRadioChnage}/> 보통</label>
                                                    <label><input type="radio" name="hq3" value="6" onChange={handleRadioChnage}/> 약간 그러함</label>
                                                    <label><input type="radio" name="hq3" value="7" onChange={handleRadioChnage}/> 많이 그러함</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">4. 나는 내 일에 몰두하는 편이고, 스스로 세운 기대치를 달성하고 있다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="hq4" value="1" onChange={handleRadioChnage}/> 전혀 아님</label>
                                                    <label><input type="radio" name="hq4" value="3" onChange={handleRadioChnage}/> 많이 아님</label>
                                                    <label><input type="radio" name="hq4" value="4" onChange={handleRadioChnage}/> 약간 아님</label>
                                                    <label><input type="radio" name="hq4" value="5" onChange={handleRadioChnage}/> 보통</label>
                                                    <label><input type="radio" name="hq4" value="6" onChange={handleRadioChnage}/> 약간 그러함</label>
                                                    <label><input type="radio" name="hq4" value="7" onChange={handleRadioChnage}/> 많이 그러함</label>
                                                </dd>
                                            </dl>
                                        </li>
							        </ul>
						        </fieldset>
                                <CheckButton goResult={goResult} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckHappy